import { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { useAppSelector } from '../../../../app/hook';
import { wizardState } from '../../../../features/bot/botSlice';
import { AIKittyType } from '../../../../features/bot/types';

type Props = {
  formBuilder: UseFormReturn<any, any>;
};

function BotEditAgentWelcomingName({ formBuilder }: Props) {
  const wizard = useAppSelector(wizardState);
  const { t } = useTranslation();

  const {
    setValue,
    formState: { errors },
    register,
  } = formBuilder;

  useEffect(() => {
    if (wizard.bot_config && (wizard.bot_config as AIKittyType)?.welcoming) {
      setValue('welcoming', (wizard.bot_config as AIKittyType)?.welcoming);
    }
    if (wizard.bot_config && (wizard.bot_config as AIKittyType)?.instructions?.agent_name) {
      setValue('agent_name', (wizard.bot_config as AIKittyType)?.instructions?.agent_name);
    }
    return () => {
      setValue('welcoming', '');
      setValue('agent_name', '');
    };
  }, [wizard.bot_config]);

  return (
    <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-5 tw-flex tw-mb-5">
      <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-2 tw-flex">
        <div className="tw-self-stretch tw-text-gray-900 tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
          1. {t('Wizard/PlugAndPlayInfos/key23')}
        </div>
      </div>
      <div className="tw-w-full tw-justify-start tw-items-start tw-gap-2 tw-flex tw-flex-col">
        <Form.Group className="tw-w-full">
          <Form.Label>{t('Wizard/validationLabels/key9')} *</Form.Label>
          <Form.Control
            isInvalid={!!errors.agent_name}
            maxLength={30}
            {...register('agent_name')}
            className="tw-h-10 tw-px-4 tw-py-2.5 tw-bg-white tw-rounded-md tw-shadow-sm tw-border tw-border-gray-300 tw-justify-start tw-items-center tw-inline-flex"
          />
          <Form.Control.Feedback type="invalid" className="d-block font-poppins">
            {errors?.agent_name?.message as string}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="tw-w-full">
          <Form.Label>{t('Wizard/AiAdditionalInfo/key5')}</Form.Label>
          <Form.Control
            as={'textarea'}
            maxLength={500}
            placeholder={t('Wizard/AiAdditionalInfo/key6').toString()}
            defaultValue={(wizard.bot_config as AIKittyType).welcoming ?? ''}
            {...register('welcoming')}
          />
        </Form.Group>

        <Form.Group className="tw-w-full">
          <Form.Label>{t('Wizard/AiAdditionalInfo/key4')}</Form.Label>
          <Form.Control
            placeholder={t('KnowledgeBasesCreateAssistantBot/ph-01')}
            type="text"
            as={'textarea'}
            maxLength={10000}
            rows={12}
            defaultValue={(wizard.bot_config as AIKittyType).additional_instructions ?? ''}
            {...register('additional_instructions')}
          />
        </Form.Group>
      </div>
    </div>
  );
}

export default WrappedErrorBoundary(BotEditAgentWelcomingName);
